
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_630_2457)"}},[_c('path',{attrs:{"d":"M4.003 1.167A.667.667 0 014.669.5h5.334a.667.667 0 110 1.333H4.669a.667.667 0 01-.666-.666zM6.669 10.5a.667.667 0 101.334 0v-4a.667.667 0 10-1.334 0v4zm.667-7.333a6 6 0 100 12 6 6 0 000-12zm-4.667 6a4.667 4.667 0 119.334 0 4.667 4.667 0 01-9.334 0zm10.864-3.53a.667.667 0 10.942-.944l-1.336-1.33a.667.667 0 10-.942.944l1.336 1.33z","fill":"#000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_630_2457"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    